// Global filters for Vue 3 - using global properties
export const filters = {
    formatAddress(value) {
        if (!value) { return ''; }
        value = value.toString();
        return value.replace(/\n/g, ", ");
    }
};

// Function to install filters globally
export function installFilters(app) {
    app.config.globalProperties.$filters = filters;
}